<template>
    <others>
        <div class="p-6 bg-white border-b border-gray-200 overflow-hidden shadow-sm sm:rounded-lg">
            <div class="flex items-center justify-between gap-4 mb-4">
                <div>
                    <p class="text-lg font-medium">{{ resource.title }}</p>
                    <p class="text-sm text-gray-500" v-if="resource.description">{{ resource.description }}</p>
                </div>
                <div class="flex items-center gap-2">
                    <breeze-button type="button" :disabled="requestForm.processing" @click="sendRequest">Send Request</breeze-button>
                    <button-link :href="route('others.resource.list')">Back</button-link>
                </div>
            </div>

            <breeze-table
                :fields="fields"
                :items="resource.submissions"
                :canView="isAdmin()"
            >
                <template #branch="data">
                    {{ data.item.branch.title }}
                </template>
                <template #file="data">
                    <a v-if="data.item.file_url" :href="data.item.file_url" target="_blank" class="text-indigo-600 hover:text-indigo-900">
                        {{ data.item.file_name }}
                    </a>
                    <span v-else>Not uploaded</span>
                </template>
                <template #status="data">
                    {{ statusLabel(data.item.status) }}
                    <div class="mt-1 text-xs text-red-600 whitespace-normal" v-if="data.item.decline_reason">
                        {{ data.item.decline_reason }}
                    </div>
                </template>
                <template #uploaded_by="data">
                    {{ data.item.uploader ? data.item.uploader.name : '-' }}
                </template>
                <template #reviewed_by="data">
                    {{ data.item.reviewer ? data.item.reviewer.name : '-' }}
                </template>
                <template #action="data">
                    <div class="flex flex-wrap items-center gap-2" v-if="data.item.status === 'pending_review' && decliningId !== data.item.id">
                        <breeze-button type="button" :disabled="acceptForm.processing" @click="acceptSubmission(data.item)">Accept</breeze-button>
                        <breeze-button type="button" class="bg-red-600 hover:bg-red-700" @click="startDecline(data.item)">Decline</breeze-button>
                    </div>
                    <div class="mt-3" v-if="decliningId === data.item.id">
                        <breeze-input v-model="declineForm.reason" class="w-full" placeholder="Reason"/>
                        <breeze-input-error :message="declineForm.errors?declineForm.errors.reason:''" />
                        <div class="flex items-center gap-2 mt-2">
                            <breeze-button type="button" :disabled="declineForm.processing" @click="declineSubmission(data.item)">Submit Reason</breeze-button>
                            <breeze-button type="button" class="bg-red-600 hover:bg-red-700" @click="decliningId = null">Cancel</breeze-button>
                        </div>
                    </div>
                    <span v-if="data.item.status !== 'pending_review'">-</span>
                </template>
            </breeze-table>
        </div>
    </others>
</template>

<script>
import Others from '@/Pages/Others/Others'
import ButtonLink from '@/Components/ButtonLink'
import BreezeButton from '@/Components/Button'
import BreezeInput from '@/Components/Input'
import BreezeInputError from '@/Components/InputError'
import BreezeTable from '@/Components/Table'
import {useForm} from '@inertiajs/inertia-vue3'

export default {
    components: {
        Others,
        ButtonLink,
        BreezeButton,
        BreezeInput,
        BreezeInputError,
        BreezeTable,
    },
    props: ['resource'],
    data() {
        return {
            decliningId: null,
            acceptForm: useForm({}),
            requestForm: useForm({}),
            declineForm: useForm({
                reason: '',
            }),
            fields: [
                {'key': 'branch', 'label': 'Branch'},
                {'key': 'file', 'label': 'File'},
                {'key': 'status', 'label': 'Status'},
                {'key': 'uploaded_by', 'label': 'Uploaded By'},
                {'key': 'reviewed_by', 'label': 'Reviewed By'},
                {'key': 'action', 'label': 'Action'},
            ],
        }
    },
    methods: {
        statusLabel(status) {
            return status.replace('_', ' ').replace(/\b\w/g, (letter) => letter.toUpperCase());
        },
        sendRequest() {
            this.requestForm.post(route('others.resource.send-request', this.resource.id), {
                preserveScroll: true,
            });
        },
        acceptSubmission(submission) {
            this.acceptForm.post(route('others.resource-submission.accept', submission.id), {
                preserveScroll: true,
            });
        },
        startDecline(submission) {
            this.decliningId = submission.id;
            this.declineForm.reason = submission.decline_reason || '';
        },
        declineSubmission(submission) {
            this.declineForm.post(route('others.resource-submission.decline', submission.id), {
                preserveScroll: true,
                onSuccess: () => {
                    this.decliningId = null;
                    this.declineForm.reset();
                },
            });
        },
        isAdmin() {
            const role = this.$page.props.auth.user.role;

            return role?.type === 'super' || role?.name === 'Super Admin';
        },
    },
}
</script>
